export default __webpack_public_path__ + "static/media/BloudraadBaby.d4e20047.jpeg";